import type { PestTone } from '@ps/common-features/helpers/pestCoverage'
import { WORK_ORDER_STATUS } from 'src/api/constants/workOrder'
import type { WorkOrder } from 'src/api/domains/service-tracking/serviceTracking.types'

import { TREATMENT_BUCKET, type TreatmentBucket } from '../constants/treatment'

/** The tones that mean the work is settled, once the work order is finished. */
const SETTLED_TONES: PestTone[] = ['covered', 'paid']

/**
 * Determines whether a treatment entry is in progress, excluded, or completed.
 *
 * Reads the tone rather than the status so the buckets follow the shared mapping: a new
 * status lands in the right section by virtue of its row, with no list to keep in step.
 */
export const resolveTreatmentBucket = (
  tone: PestTone | null,
  workOrderStatusSlug?: WorkOrder['status']['slug'],
): TreatmentBucket => {
  if (tone === 'excluded') return TREATMENT_BUCKET.EXCLUDED

  if (
    tone !== null &&
    SETTLED_TONES.includes(tone) &&
    workOrderStatusSlug === WORK_ORDER_STATUS.COMPLETED
  )
    return TREATMENT_BUCKET.COMPLETED

  return TREATMENT_BUCKET.IN_PROGRESS
}
